// An inline-template block of the root template that re-renders only when the root members it reads change.
export default function rootScoped({ data = [], methods = [] }) {
  return {
    computed: Object.fromEntries(
      data.map((key) => [
        key,
        function () {
          return this.$root[key];
        },
      ]),
    ),
    methods: Object.fromEntries(
      methods.map((key) => [
        key,
        function (...args) {
          return this.$root[key](...args);
        },
      ]),
    ),
  };
}
